import { render, staticRenderFns } from "./TgHistoryReward.vue?vue&type=template&id=0911e25e"
import script from "./TgHistoryReward.vue?vue&type=script&lang=js"
export * from "./TgHistoryReward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports